import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAqLnniSqH0EY6TL4sjxU1uCitLaBiBnQM",
  authDomain: "real-estate-b680f.firebaseapp.com",
  projectId: "real-estate-b680f",
  storageBucket: "real-estate-b680f.firebasestorage.app",
  messagingSenderId: "667760728236",
  appId: "1:667760728236:web:7ab5f66d063a074d5a2709"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment)
let analytics;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { app, analytics };
